import React from 'react';
import { Loader2 } from 'lucide-react';

export default function LoadingSpinner({ text = 'Загрузка...' }) {
  return (
    <div className="flex items-center justify-center py-12">
      <Loader2 className="w-6 h-6 animate-spin text-blue-600 dark:text-blue-400 mr-3" />
      <span className="text-text-muted text-lg">{text}</span>
    </div>
  );
}
